import { EditorJsonModel } from '../../editor.json.model';

export namespace EditorActions {
  export class Add {
    static readonly type = getActionName('Add Editor');
    constructor(readonly payload: EditorJsonModel) {}
  }

  export class Delete {
    static readonly type = getActionName('Delete Editor');
    constructor(readonly payload: EditorJsonModel) {}
  }

  export class Edit {
    static readonly type = getActionName('Edit Editor');
    constructor(readonly payload: EditorJsonModel) {}
  }

  export class Fetch {
    static readonly type = getActionName('Fetch Editors');
  }

  export class FetchSuccess {
    static readonly type = getActionName('Fetch Editors success');
    constructor(readonly payload: EditorJsonModel[]) {}
  }

  function getActionName(type: string) {
    return `[Editor] ${type}`;
  }
}
